import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useLeasingContacts from './useLeasingContacts';

const useSingleLeasingContact = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading } = useLeasingContacts(false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleLeasingContact;
